/** The mosy mark: a friendly coral octopus (one creature, many arms in
 *  many channels), drawn in the app palette — vermilion body, paper
 *  eyes, ink pupils. Same drawing as public/favicon.svg and the PWA
 *  icons, minus the background tile: it sits directly on the surface
 *  behind it. */
export const MosyMark = ({ size = 30 }: { size?: number }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} aria-label="mosy">
    <path
      fill="#E2542C"
      d="M16.5 32
        C13.5 36 13 40 13 44
        a3.1 3.1 0 0 0 6.2 0
        a2.05 2.05 0 0 1 4.1 0
        a3.1 3.1 0 0 0 6.2 0
        a2.05 2.05 0 0 1 4.1 0
        a3.1 3.1 0 0 0 6.2 0
        a2.05 2.05 0 0 1 4.1 0
        a3.1 3.1 0 0 0 6.2 0
        C51 40 50.5 36 47.5 32
        Q32 38 16.5 32 Z"
    />
    <g stroke="#E2542C" fill="none" strokeWidth="4.2" strokeLinecap="round">
      <path d="M14.5 38 C10.5 40.5 8 37.5 10 34.5" />
      <path d="M49.5 38 C53.5 40.5 56 37.5 54 34.5" />
    </g>
    <ellipse cx="32" cy="27" rx="17" ry="14.5" fill="#E2542C" />
    <circle cx="20.5" cy="32" r="2.3" fill="#F29B77" />
    <circle cx="43.5" cy="32" r="2.3" fill="#F29B77" />
    <circle cx="25.5" cy="27.5" r="4.6" fill="#FAFAF7" />
    <circle cx="38.5" cy="27.5" r="4.6" fill="#FAFAF7" />
    <circle cx="26.2" cy="28.4" r="2.2" fill="#14130F" />
    <circle cx="37.8" cy="28.4" r="2.2" fill="#14130F" />
    <circle cx="26.9" cy="27.6" r="0.8" fill="#FAFAF7" />
    <circle cx="38.5" cy="27.6" r="0.8" fill="#FAFAF7" />
    <path d="M29.5 33.5 Q32 35.8 34.5 33.5" stroke="#14130F" fill="none" strokeWidth="1.9" strokeLinecap="round" />
  </svg>
);

export default MosyMark;
